import EditControlRepo from './EditControlRepo';

export default EditControlRepo;
